var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/containers/schedule-form-container.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import BundleContainer from 'soapbox/features/ui/containers/bundle-container';
import { ScheduleForm } from 'soapbox/features/ui/util/async-components';

const ScheduleFormContainer = props => /*#__PURE__*/React.createElement(BundleContainer, {
  fetchComponent: ScheduleForm,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 9,
    columnNumber: 3
  }
}, Component => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 10,
    columnNumber: 19
  }
})));

export default ScheduleFormContainer;